<template>  
  <v-container grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 md4>
        <form @submit.prevent="onsubmit">
          <v-card>                    
            <v-card-text>      
              <v-autocomplete outlined dense
                v-model="fm.kompetisi_id"
                label="Kompetisi"
                :items="kompetisies"
                item-text="name"
                item-value="id"
                @keyup="searchKompetisi"
                :loading="kompetisiLoading"
                :error="!!error.kompetisi_id.length"
                :error-messages="error.kompetisi_id"
                autocomplete="off"
              >
                <template v-slot:item="data">                  
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>                      
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>

              <v-text-field outlined dense
                label="Nomor"
                v-model="fm.no"
                append-icon="code"
                type="text"
                :error="!!error.no.length"
                :error-messages="error.no"
                style="max-width:100px"
              ></v-text-field> 

              <v-text-field outlined dense
                label="Name"
                v-model="fm.name"
                append-icon="brightness_medium"
                type="text"
                :error="!!error.name.length"
                :error-messages="error.name"
              ></v-text-field>                                    
              
              <v-text-field outlined dense
                label="Akronim"
                v-model="fm.akronim"
                append-icon="filter_frames"
                type="text"
                :error="!!error.akronim.length"
                :error-messages="error.akronim"
              ></v-text-field>

              <v-text-field outlined dense
                label="Tagline"
                v-model="fm.tagline"
                append-icon="filter_frames"
                type="text"
                :error="!!error.tagline.length"
                :error-messages="error.tagline"
              ></v-text-field>

              <v-text-field outlined dense
                label="Description"
                v-model="fm.description"
                append-icon="description"
                type="text"
                :error="!!error.description.length"
                :error-messages="error.description"
              ></v-text-field>

              <v-autocomplete  outlined dense
                v-model="fm.partai_id"
                label="Partai"
                :items="partaies"
                :item-text="['name','akronim']"
                item-value="id"
                @keyup="searchPartai"
                :loading="partaiLoading"
                :error="!!error.partai_id.length"
                :error-messages="error.partai_id"
              >
                <template v-slot:selection="data">
                  <v-list-item-avatar>
                    <v-img v-if="data.item.tinyFileBase64" :src="data.item.tinyFileBase64"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.no }}. {{ data.item.akronim}}</v-list-item-title>                                          
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">                  
                  <template>
                    <v-list-item-avatar>
                      <v-img v-if="data.item.tinyFileBase64" :src="data.item.tinyFileBase64"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ data.item.no }}. {{ data.item.akronim}}</v-list-item-title>                      
                      <span>{{ data.item.name }}</span>                                            
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>

              <v-menu
                v-model="colorpicker"              
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field outlined dense                  
                    v-model="fm.color"
                    label="Color"
                    append-icon="invert_colors"                  
                    v-on="on"
                    style="width:150px;"
                    :background-color="fm.color"
                    hide-details
                  ></v-text-field>
                </template>
                <v-color-picker v-model="fm.color"></v-color-picker>                
              </v-menu>
              
              <v-switch v-model="fm.status" :label="fm.status === 1?'Status:Active':'Status:Inactive'" :true-value="1" :false-value="0"></v-switch>          
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
            </v-card-actions>
          </v-card>
        </form>   
      </v-flex>   
      <v-flex xs12 md3>
        <v-card v-if="isUpdate" class="grey">
          <v-responsive :aspect-ratio="1">
            <v-img :aspect-ratio="1" v-if="fm.originalFileBase64" :src="fm.originalFileBase64">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center" v-if="loading">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-btn class="ma-3" @click="show=true" :loading="loading" style="position:absolute; top:5px; right:5px" fab small dark color="info">
              <v-icon>camera_alt</v-icon>
            </v-btn>                                  
          </v-responsive>  
        </v-card>
        <my-upload style="width:100%" field="img"
          @crop-success="cropSuccess"        
            :width="300"
            :height="300"         
            lang-type="en"
            :value.sync="show"
            v-model="show"                
            img-format="png">            
        </my-upload>
      </v-flex>         
    </v-layout>
  </v-container>    
</template>

<script>
import {debounce} from 'lodash'
import MyUpload from 'vue-image-crop-upload';
import Model from '@/app/models/master/Calon'
const  model = new Model();

export default {
  components:{MyUpload},
  data : () => ({  
    fm:{no:null, name: null, kompetisi_id:null, partai_id:null, akronim:null, tagline:null, description:null, color:'#fff', status:1},
    error:{no:[], name:[], kompetisi_id:[], partai_id:[], akronim:[], tagline:[], description:[], color:[], status:[]},
    loading: false,
    isUpdate: false,        
    colorpicker:false,  
    show : false,   
    kompetisies : [], kompetisiLoading : false,
    partaies : [], partaiLoading : false,
  }),
  computed:{
    /*types(){
      let obj = this.$store.getters.DICTIONS.ProductType;
      return Object.keys(obj).map(function(key) { return {id:parseInt(key), name: obj[key]}; });
    }*/
  },
  watch:{
    'fm.kompetisi_id'(newId, oldId){
      if(oldId===null && newId !== null){
        model.kompetisi({id:newId}).then(data=>{
          this.kompetisies.push(data);
        })    
      }
    },
    'fm.partai_id'(newId, oldId){
      if(oldId===null && newId !== null){
        model.partai({id:newId,expand:'tinyFileBase64'}).then(data=>{
          this.partaies.push(data);
        })    
      }
    }
  }, 
  mounted(){
    this.init(); this.searchKompetisi({target:{}});
  },
  methods: {   
    searchPartai : debounce(function(e){
      this.partaiLoading = true;
      model.partaies({q:e.target.value, expand:'tinyFileBase64'}).then(res=>{
        this.partaies = res.data;
        this.partaiLoading = false;
      })
    },400),

    searchKompetisi : debounce(function(e){
      this.kompetisiLoading = true;
      model.kompetisies({q:e.target.value}).then(res=>{
        this.kompetisies = res.data;
        this.kompetisiLoading = false;
      })
    },400),

    init(){
      if(this.$route.query.id){
        this.isUpdate = true;
        this.loading  = false;     
        model.view({id:this.$route.query.id, expand:'thumbFileBase64,originalFileBase64'}).then(data=>{                
          Object.assign(this.fm, data);
          this.loading = false;            
        })
      }
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{          
          this.responseSubmit(res)
          this.$router.replace({name:'master/calon'})
        })
      } else {        
        model.create(this.fm).then(res=>{
          this.responseSubmit(res)
          this.$router.replace({query:{id:res.data.id}})
          this.init();
        })
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});                                    
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    },

    cropSuccess(imgDataUrl, field){
        //console.log('-------- crop success --------');
        this.imgDataUrl = imgDataUrl;
        
        var block = imgDataUrl.split(";");
        var contentType = block[0].split(":")[1];// In this case "image/gif"
        var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
        var blob = this.b64toBlob(realData, contentType);

        var FormData = require('form-data');
        let formData = new FormData();

        formData.append('file', blob, 'image');
        formData.append('reff_id', this.fm.id);
        formData.append('reff_type', 2);        
        
        this.loading = true;
        model.uploadImage(formData, {expand:'originalFileBase64'}).then(res=>{
          this.loading = false;
          if(res.status===200)
            this.fm.originalFileBase64 = res.data.originalFileBase64;
        });
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
.vue-image-crop-upload .vicp-wrap{      
    height: 65%;
    width : 80%;
    min-height:330px;
    max-width: 600px;
}
</style>